import QUEUE from './queue'
import ITEM from './item'
import THIRD_QUEUE from './third-queue'
import IN_HOUSE_QUEUE from './in-house-queue'
import CCCS_QUEUE from './cccs-queue'
import BANKRUPTCY_QUEUE from './bankruptcy-queue'
import MISCELLANEOUS_QUEUE from './miscellaneous-queue'
import IN_HOUSE_OVERFLOW_QUEUE from './in-house-overflow-queue'
import IN_HOUSE_SPECIAL_QUEUE from './in-house-special-queue'

export const LCS_QUEUE_LAYOUT_SETTING = {
  QUEUE,
  ITEM,
  THIRD_QUEUE,
  IN_HOUSE_QUEUE,
  CCCS_QUEUE,
  BANKRUPTCY_QUEUE,
  MISCELLANEOUS_QUEUE,
  IN_HOUSE_SPECIAL_QUEUE,
  IN_HOUSE_OVERFLOW_QUEUE
}
